import { EQUIP_TABS, EquipTabKey } from './equipTabConfig';
import '../product/ProductTabBar.css';

interface EquipTabBarProps {
  activeTab: EquipTabKey;
  onChange: (tab: EquipTabKey) => void;
}

function EquipTabBar({ activeTab, onChange }: EquipTabBarProps) {
  return (
    <div className="product-tabs" role="tablist" aria-label="제조설비 상세 탭">
      {EQUIP_TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.key}
          className={`product-tabs__item${activeTab === tab.key ? ' is-active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default EquipTabBar;
